// import 'babel-polyfill';
import weatherNetMap from './weatherNetMap_core';
import SearchDialog from './modules/SearchDialog';
import _pullAll from 'lodash/pullAll';
import debounce from 'lodash/debounce';

// URL parsing
import url from 'url';
import qs from 'qs';

// Import Vue components
import { createApp as createVueApp } from 'vue';
import MapSidebar from './MapSidebar.vue';

// Import UI classes
//...
import './css/weatherNetLive.css';

// Import Layer Managers
import WxObsLayerManager from './modules/layers/WxObsLayerManager';
import AlertsLayerManager from './modules/layers/AlertsLayerManager';
import RefreshableTileLayerManager from './modules/layers/RefreshableTileLayerManager';
import LSRLayerManager from './modules/layers/LSRLayerManager';
import SFCAnalysisLayerManager from './modules/layers/SFCAnalysisLayerManager';
import SkyCamsLayerManager from './modules/layers/SkyCamsLayerManager';
import TropicalLayerManager from './modules/layers/TropicalLayerManager';
import ConvectiveLayerManager from './modules/layers/ConvectiveLayerManager';
import OutlookLayerManager from './modules/layers/OutlookLayerManager';
import FireLayerManager from './modules/layers/FireLayerManager';
import EarthquakeLayerManager from './modules/layers/EarthquakeLayerManager';
import RefreshableLoopingTileLayerManager from './modules/layers/RefreshableLoopingTileLayerManager';

var liveMap;

$(function() {
	initLiveMap();
	setupUI();
});

function initLiveMap() {

	var liveMapOptions = {infoBoxId: 'infobox'};
	var uri = url.parse(document.location.href);
	var uriqs = qs.parse(uri.query);

	try {
		// Lazy handling of stored map view, ignore if anything is invalid
		var storedMapView = null;
		if(window.localStorage) storedMapView = window.localStorage.getItem('weatherusa.weatherlive.mapview');
		if(typeof uriqs.q === 'string') {
			// Use map position from URL (priority)
			var ll = uriqs.q.split(',');
			if(ll.length > 1) {
				liveMapOptions.mapStartCenter = L.latLng(parseFloat(ll[0]), parseFloat(ll[1]));
			}

			if(typeof uriqs.zoom === 'string') {
				liveMapOptions.mapStartZoom = uriqs.zoom;
			}

		} else if(storedMapView) {
			// Use map position from localStorage
			var ll = storedMapView.split(',');
			if(ll.length === 3) {
				var lat = parseFloat(ll[0]);
				var lon = parseFloat(ll[1]);
				var z = parseInt(ll[2]);
				liveMapOptions.mapStartCenter = L.latLng(lat, lon);
				liveMapOptions.mapStartZoom = z;
			}
		}
	}
	catch(err) {
		console.log(err);
	}
	
	liveMap = new weatherNetMap('map_canvas', liveMapOptions);

	liveMap.loadingListeners['toolbar'] = function(stack) {
		// console.log(stack, stack.length);
		if(stack.length > 0) {
			$('#indicator_loading').removeClass('d-none');
		} else {
			$('#indicator_loading').addClass('d-none');
		}
	};
	
	// Load the Leaflet map core and layers
	liveMap.mapInit();

	if(window.localStorage) { 
		var funcStoreMapView = debounce(function() {
			// Save map view to localStorage
			var ll = liveMap.map.getCenter();
			var z = liveMap.map.getZoom();
			var str = '' + ll.lat + ',' + ll.lng + ',' + z;
			window.localStorage.setItem('weatherusa.weatherlive.mapview', str);
		}, 2000);

		// Listen for map view changes - goes here after init and conveniently ignores trying to use original map position
		liveMap.map.on('moveend zoomend', function() {
			funcStoreMapView();
		});
	}
	
	// Setup sidebar and layer management
	var layerUIList = [];

	// Load map plugins and extended layers
	liveMap.layerManagers.radarNexradL2 = null;
	liveMap.Plugins.GLRadarLayer = import('./modules/layers/GLRadarLayer.js').then((addon) => {
		liveMap.layerManagers.radarNexradL2 = new addon.default('radarNexradL2', liveMap);
	});

	if(window._userProxy && window._userProxy.hasAssets) {
		liveMap.layerManagers.clientAssets = null;
		liveMap.Plugins.ClientAssets = import('./modules/layers/ClientAssetsLayerManager.js').then((addon) => {
			liveMap.layerManagers.clientAssets = new addon.default('clientAssets', liveMap);
			liveMap.layerManagers.clientAssets.attachLayer();
		});
		$('#map_controls_tabs').removeClass('d-none');
		$('#map_controls_tabs a').on('click', function(e) {
			e.preventDefault();
			var tabRef = $(this).attr('href');
			//console.log(this, tabRef);
			$('#tab_assets, #vue_MapSidebar').addClass('d-none');
			$('#map_controls_tabs a').removeClass('active');
			$(tabRef).removeClass('d-none');
			$(this).addClass('active');
		});
	}
	
	// Load all Layer Managers
	liveMap.layerManagers.wxObs = new WxObsLayerManager('wxObs', liveMap);
	liveMap.layerManagers.alerts = new AlertsLayerManager('alerts', liveMap);
	liveMap.layerManagers.lsr = new LSRLayerManager('lsr', liveMap);
	liveMap.layerManagers.sfcanalysis = new SFCAnalysisLayerManager('sfcanalysis', liveMap);
	liveMap.layerManagers.skyCams = new SkyCamsLayerManager('skyCams', liveMap);
	liveMap.layerManagers.tropical = new TropicalLayerManager('tropical', liveMap);
	liveMap.layerManagers.convective = new ConvectiveLayerManager('convective', liveMap);
	liveMap.layerManagers.swo = new OutlookLayerManager('swo', liveMap);
	liveMap.layerManagers.fire = new FireLayerManager('fire', liveMap);
	liveMap.layerManagers.earthquake = new EarthquakeLayerManager('earthquake', liveMap);
	// TODO TESTING
	liveMap.layerManagers.radarLoop = new RefreshableLoopingTileLayerManager('radarLoop', liveMap);

	// Callback: setup injected layer managers & attach default layers once Vue has fully loaded the sidebar
	liveMap._handleLayerList = function () {
		for(let cl of liveMap._layerList) {
			for(let layer of cl.layers) {
				if(layer.type === 'tile' || layer.type === 'wms' || layer.type === 'wmts') {
					liveMap.layerManagers[layer.layerId] = new RefreshableTileLayerManager(layer.layerId, liveMap, layer.type, layer.url, layer.options, layer.sublayers);
				}
			}
		}

		var defaultEnabled = ['radar', 'alerts', 'wxObs'];

		var storedLayers = null;
		if(window.localStorage) storedLayers = JSON.parse(window.localStorage.getItem('weatherusa.weatherlive.layers'));

		var inlayers = [];
		var invalids = [];
		if(typeof uriqs.layers === 'string') {
			// Use layers list from URL (priority)
			inlayers = uriqs.layers.split(',');
		} else if(storedLayers) {
			// Use saved layers list in localStorage
			inlayers = storedLayers;
		}

		if(inlayers.length) {
			for(let inl=0; inl < inlayers.length; inl++) {
				// Shim for v1 map (app & private links) to replace "obs-t" with "wxObs-t"
				if(inlayers[inl] == 'obs-t') inlayers[inl] = 'wxObs-t';
				if(inlayers[inl] == 'obs') inlayers[inl] = 'wxObs';

				// Find layer base ID, if needed
				// see if '-' in name, if so this is sublayer or filter option
				var larr = inlayers[inl].split('-');
				var lbase = larr[0];
				// FIXME should use SetOption not direct variable access
				if(larr.length > 1 && window.liveMap.layerManagers[lbase] && window.liveMap.layerManagers[lbase].dataOptions && window.liveMap.layerManagers[lbase].dataOptions.mVar) {
					window.liveMap.layerManagers[lbase].dataOptions.mVar = larr[1];
					inlayers[inl] = lbase;
				}

				if(!(lbase in window.liveMap.layerManagers)) {
					invalids.push(inlayers[inl]);
				}
			}
			// Remove any invalid layer names
			_pullAll(inlayers, invalids);

			defaultEnabled = inlayers;
		}
		
		liveMap.sidebar.activeLayers = defaultEnabled;
	}

	window.liveMap = liveMap;
}

function setupUI() {
	liveMap.sidebar = createVueApp(MapSidebar).mount('#vue_MapSidebar');

	$('#map_controls_handle').on('click', function() {
		if( ! $('#map_controls_wrapper').hasClass('controls-open') && ! $('#map_controls_wrapper').hasClass('controls-closed')) {
			// Detect initial state for proper toggle
			if($('#map_controls_wrapper').css('right') === '0px') {
				$('#map_controls_wrapper, #map_canvas').addClass('controls-open');
			} else {
				$('#map_controls_wrapper, #map_canvas').addClass('controls-closed');
			}
		}
		if($('#map_controls_wrapper').hasClass('controls-open')) {
			// Close it
			$('#map_controls_wrapper, #map_canvas').removeClass('controls-open').addClass('controls-closed');
		} else {
			// Open it
			$('#map_controls_wrapper, #map_canvas').removeClass('controls-closed').addClass('controls-open');
		}
	});

	$(function() {
		$('[data-toggle="tooltip"]').tooltip();
	});

	document.getElementById('map_controls_wrapper').addEventListener('transitionend', function() {
		// console.log('transition END');
		liveMap.map.invalidateSize();
	});
	document.getElementById('map_controls').addEventListener('transitionend', function(e) {
		e.stopPropagation();
	});

	$('#infobox_wrapper .close-button').on('click', function(e) {
		e.preventDefault();
		$('#infobox_wrapper').removeClass('open');
	});

	liveMap._searchDialog = new SearchDialog('#qstr', '#qstr_dropdown');
	liveMap._searchDialog.attachSearchFormListeners();

	$('#action_geolocate').on('click', (e) => {
		e.preventDefault();
		if(navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(liveMap.geolocated.bind(liveMap), liveMap.geolocationError.bind(liveMap));
		}
		$('#fullscreen_search').removeClass('search-mobile');
	});
	$('#action_fullscreen').on('click', (e) => {
		e.preventDefault();
		liveMap.launchFullScreen(document.documentElement);
	});
	$('#action_search').on('click', (e) => {
		e.preventDefault();
		$('#fullscreen_search').toggleClass('search-mobile');
	})

	// Refresh map layers automatically
	liveMap.updateAllLayersPeriodic();
	
}
